import styled from 'styled-components';
import { white } from '../../../../app/js/components/loggedout/shared-styles/Colors';

export const SplashLogo = styled.div`
    background: ${white};
    text-align : center;
    padding: 0.8rem;
    & > a > img {
        width: 17.6rem;
    }
`